import { combineReducers } from 'redux';
import listings from './reducers/listings';
import ui from './reducers/ui';

export default combineReducers({
  listings,
  ui
});
